module.exports = __webpack_public_path__ + "static/media/DSC09974.86ae8c9f.jpg";